import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import StarsField from '../../fields/StarsField/StarsField';
import TextAreaField from 'shared-components/reduxForms/fields/TextAreaField/TextAreaField';
import { ATTENDEE_REVIEW_FORM } from '../../constants/formNames';
import submitAttendeeReviewForm from '../../submit/submitAttendeeReviewForm';
import validateAttendeeReviewForm from '../../validate/validateAttendeeReviewForm';
import Button from '../../../../../elements-buttons/Button';

class AttendeeReviewForm extends React.Component {
  componentDidMount () {
    analyticsIntegrations.trackEvent('review_form_viewed', this.props.review);
  }

  render () {
    const {
      handleSubmit = () => {},
      isPatching = false,
      error
    } = this.props;

    return (
      <form className="AttendeeReviewForm" onSubmit={handleSubmit(submitAttendeeReviewForm)}>
        <div className="flex column">
          <h5>Rate the venue</h5>

          <Field
            className="margin-lg-bottom"
            component={StarsField}
            name="stars"
            errorMessage="Please enter a rating"
          />

          <h5>Write a review for the venue</h5>

          <Field
            className="margin-lg-bottom"
            inputClassName="flex-grow"
            component={TextAreaField}
            name="review_text"
            errorMessage="Your review must be more than five characters long"
          />


          <Button
            category="primary"
            className="margin-sm-top"
            isLoading={isPatching}
            disabled={!!error}
          >
            Send Feedback
          </Button>

          {
            !!error &&
              <div className="error margin-md-top">{error}</div>
          }
        </div>
      </form>
    );
  }
}

AttendeeReviewForm.propTypes = {
  handleSubmit: PropTypes.func,
  isPatching: PropTypes.bool,
  review: PropTypes.object,
  error: PropTypes.string
};

const config = {
  form: ATTENDEE_REVIEW_FORM,
  validate: validateAttendeeReviewForm
};

export default reduxForm(config)(AttendeeReviewForm);
